import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

class ContactList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return <div dangerouslySetInnerHTML={{ __html: content.contactList }} />;
    }
}

export default ContactList;
